import { BufferGeometry, LineSegments, Vector2 } from 'three';
import { ENTITY_RENDER_ORDER } from '@/editor/constant/entity';
import { IPoint2d } from '@/editor/math/IPoint2d';
import { pixelRatio2d } from '@/editor/math/const';
import { globalStores } from '@/editor/stores';
import { MaterialStore } from '@/editor/stores/materialStore';
import BaseModel2d from './BaseModel2d';

export interface IRulerGuideLineInfo {
  start: IPoint2d;
  end: IPoint2d;
}

export class RulerGuideLineModel extends BaseModel2d {
  constructor() {
    super();

    globalStores.editorStateStore.sceneInfo.scene2d.scene.add(this._modelGroup);
    this.setDisplayOrder(ENTITY_RENDER_ORDER.ruler);
  }

  update(lines: IRulerGuideLineInfo[]) {
    this.clear();

    if (!lines.length) return;

    const points: Vector2[] = [];
    lines.forEach((line) => {
      points.push(new Vector2(line.start.x / pixelRatio2d, line.start.y / pixelRatio2d));
      points.push(new Vector2(line.end.x / pixelRatio2d, line.end.y / pixelRatio2d));
    });

    const geometry = new BufferGeometry();
    geometry.setFromPoints(points);

    const lineSegments = new LineSegments(geometry, MaterialStore.sharedMaterials.dashLine);
    lineSegments.computeLineDistances();
    lineSegments.frustumCulled = false;
    this._modelGroup.add(lineSegments);
  }
}
